import { z } from 'zod';

// 24-char hex string · wire representation of a MongoDB ObjectId.
// The backend converts to ObjectId when reading/writing the DB; the wire stays as string.
export const objectIdString = z
  .string()
  .regex(/^[0-9a-fA-F]{24}$/, 'Invalid ObjectId hex string');

export type ObjectIdString = z.infer<typeof objectIdString>;

// System fields present on every document. Use as `...baseDocumentFields` when composing.
export const baseDocumentFields = {
  _id: objectIdString,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  schemaVersion: z.number().int().positive(),
};

// Brazilian phone normalized to E.164: +55 + DDD(2) + subscriber(8 or 9 digits).
// Celular exige 3º dígito = 9 (regra Anatel 2016) · pega bug de auto-fill do
// Chrome que gera +5555XXXXXXXXX confundindo DDI 55 com DDD 55.
export const phoneE164 = z
  .string()
  .regex(
    /^\+55\d{2}(9\d{8}|\d{8})$/,
    'Phone must be E.164 with Brazil country code',
  );

// Free-form phone input from the public form · the backend normalizes to E.164.
export const phoneInput = z.string().trim().min(10, 'Telefone inválido').max(20, 'Telefone inválido');

// Money is always stored as integer cents. 159900 means R$ 1.599,00.
export const moneyCents = z.number().int().nonnegative();

export const emailLower = z.string().trim().toLowerCase().email();

// SHA-256 hex output (lowercase). Used for PII hashes sent to Meta CAPI.
export const sha256Hex = z.string().regex(/^[a-f0-9]{64}$/);

export const httpUrl = z.string().url();

// ISO 3166-2 state code (e.g., "SC", "SP"). Always uppercase.
export const stateCode = z
  .string()
  .length(2)
  .regex(/^[A-Z]{2}$/, 'State code must be 2 uppercase letters');

// URL-safe slug (lowercase letters, digits, hyphen). No leading/trailing hyphen.
export const slug = z
  .string()
  .min(2)
  .max(80)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'Use só letras minúsculas sem acento, números e hífen');
